import { ReactNode } from 'react';
import SideMenu, { SideMenuGroup } from '@v2/shared/Layouts/SideMenu';
import Full from '../Full';
import { FullLayoutProps } from '@v2/shared/lib/types';

/**
 * DiscountMags' chrome around the shared side-menu rail.
 *
 * The rail itself moved to `shared/Layouts/SideMenu` when TopMags' account pages needed
 * it, and it is deliberately chrome-less — it is a grid and nothing else. Everything
 * around it is Full's: the box, its measure and its spacing (see Full's `container` prop
 * and `CONTAINER_PADDING`). These pages used to state a measure and a rhythm of their
 * own here, which made them the only DiscountMags pages that did not read like the rest —
 * the `max-w-[1360px]` even overrode `.container`'s stepped widths outright, so they ran
 * to the viewport up to 1360 while every other page stepped.
 *
 * What is left is the wiring: the two DiscountMags layouts that want this shell,
 * Institutional and Account, name it instead of repeating it.
 */
export type SideMenuLayoutProps = FullLayoutProps & {
  /** The mobile toggle's text. */
  label: string;
  /** The nav landmark's name, when it should differ from the toggle's. */
  ariaLabel?: string;
  groups: SideMenuGroup[];
  /** The menu entry to mark, as its path — `/reviews`. */
  activePath?: string;
  footer?: ReactNode;
  children?: ReactNode;
};

export default function SideMenuLayout({
  children,
  label,
  ariaLabel,
  groups,
  activePath,
  footer,
  ...fullProps
}: SideMenuLayoutProps) {
  return (
    <Full {...fullProps}>
      <SideMenu
        label={label}
        ariaLabel={ariaLabel}
        groups={groups}
        activePath={activePath}
        footer={footer}
      >
        {children}
      </SideMenu>
    </Full>
  );
}
